import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  padding: 13px;
`;

export default Content;
